import cartSagas from '../../../core/js/sagas/cartSagas';
import favoriteSagas from '../../../core/js/sagas/favoritesSagas';
import initialSagas from '../../../core/js/sagas/initialSagas';
import userSagas from '../../../core/js/sagas/userSagas';
import utagSagas from '../../../core/js/sagas/utagSagas';
import { getSaytSagas } from '../../../core/js/sagas/saytSagas';

import { interfaceSagas } from '../../../legacy/js/redux-angular-interface';

import registrySagas from '../sagas/registrySagas';

export const registryStartingSagas = [
    ...cartSagas,
    ...favoriteSagas,
    ...initialSagas,
    ...getSaytSagas(),
    ...userSagas,
    ...utagSagas,
    ...interfaceSagas,
    ...registrySagas
];

export default registryStartingSagas;
